import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          <div className="text-center md:text-left">
            <div className="text-lg font-semibold mb-2">VoiceVision</div>
            <div className="text-sm text-gray-400">
              AI-powered voice and vision for the web
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8">
            <div className="flex items-center space-x-6">
              <Link 
                to="/privacy" 
                className="text-sm hover:text-primary-400 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="text-sm hover:text-primary-400 transition-colors"
              >
                Terms of Service
              </Link>
              <a 
                href="mailto:support@aichaperones.com" 
                className="text-sm hover:text-primary-400 transition-colors"
              >
                Contact
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
            © {currentYear} VoiceVision. All rights reserved.
          </div>
          
            <div className="text-sm text-gray-400">
              Part of the AI Chaperones ecosystem
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;